<template>
    <div class="field-item personal-info space-info">
      <form>
        <div class="row">
            <div class="col-md-12">
                <div class="input-block">
                    <label class="form-label">¿Tienes los estudios secundarios completos?</label>
                    <div class="check-radio">
                    <ul style="display:flex">
                        <li>
                            <label class="custom_radio me-4">
                                <input type="radio" name="budget" />
                                <span class="checkmark"></span> Si
                            </label>
                        </li>
                        <li style="margin-top: -20px;">
                            <label class="custom_radio me-4">
                                <input type="radio" name="budget" />
                                <span class="checkmark"></span> No
                            </label>
                        </li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4>Educacion</h4>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="input-block">
              <label class="focus-label">Grado</label>
              <vue-select :options="Bachelor" id="bachelor" placeholder="Select" />
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="input-block">
              <label class="focus-label">Instituto/Universidad</label>
              <input type="text" name="education['university_name'][]" class="form-control" />
            </div>
          </div>
          <div class="col-md-6 col-lg-2">
            <div class="input-block">
              <label class="focus-label">Fecha Inicio</label>
              <div class="cal-icon">
                <datepicker v-model="startdate" placeholder="Choose Date" class="form-control datetimepicker"
                  :editable="true" :clearable="false" />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-2">
            <div class="input-block">
              <label class="focus-label">Fecha Fin</label>
              <div class="cal-icon">
                <datepicker v-model="startdateOne" placeholder="Choose Date" class="form-control datetimepicker"
                  :editable="true" :clearable="false" />
              </div>
              <div class="new-addd">
                <a class="add-new text-success" id="edu_add" @click="addeducation"><i class="feather-plus-circle me-1"></i> Agregar Nuevo</a>
              </div>
            </div>
          </div>
          <div id="education_add_row">
            <div class="row" id="form-row" v-for="(education, index) in educations" :key="index">
              <div class="col-md-12">
                <h4>Educacion</h4>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="input-block">
                  <label class="focus-label">Grado</label>
                  <vue-select :options="Bachelor" placeholder="Select" />
                </div>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="input-block">
                  <label class="focus-label">Instituto/Universidad</label>
                  <input type="text" name="education['university_name'][]" class="form-control" />
                </div>
              </div>
              <div class="col-md-6 col-lg-2">
                <div class="input-block">
                  <label class="focus-label">Fecha Fin</label>
                  <div class="cal-icon">
                    <datepicker v-model="startdate" placeholder="Choose Date" class="form-control datetimepicker"
                      :editable="true" :clearable="false" />
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-2">
                <div class="input-block">
                  <label class="focus-label">Fecha Fin</label>
                  <div class="cal-icon">
                    <datepicker v-model="startdateOne" placeholder="Choose Date" class="form-control datetimepicker"
                      :editable="true" :clearable="false" />
                  </div>
                  <div class="new-addd">
                    <a id="remove_row" class="remove_row" @click="deleteeducation(index)"> Eliminar</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4>Experiencia Laboral</h4>
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="input-block">
              <label class="focus-label">Nombre de Empresa</label>
              <input type="text" name="experience['company_name'][]" class="form-control" />
            </div>
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="input-block">
              <label class="focus-label">Cargo</label>
              <input type="text" name="experience['position'][]" class="form-control" />
            </div>
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="input-block">
              <label class="focus-label">Monto</label>
              <input type="text" name="experience['mount'][]" class="form-control" />
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="input-block">
              <label class="focus-label">Fecha Inicio</label>
              <div class="cal-icon">
                <datepicker v-model="startdateThree" placeholder="Choose Date" class="form-control datetimepicker"
                  :editable="true" :clearable="false" />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="input-block">
              <label class="focus-label">Fecha Fin</label>
              <div class="cal-icon">
                <datepicker v-model="startdateFour" placeholder="Choose Date" class="form-control datetimepicker"
                  :editable="true" :clearable="false" />
              </div>
              <div class="new-addd">
                <a class="add-new text-success" id="experience_add" @click="addexperience"><i class="feather-plus-circle me-1"></i> Agregar nuevo</a>
              </div>
            </div>
          </div>
          <div id="experience_add_row">
            <div class="row" v-for="(experience, index) in experiences" :key="index">
              <div class="col-md-12">
                <h4>Experiencia Laboral</h4>
              </div>
              <div class="col-md-6 col-lg-3">
                <div class="input-block">
                  <label class="focus-label">Nombre de Empresa</label>
                  <input type="text" name="experience['company_name'][]" class="form-control" />
                </div>
              </div>
              <div class="col-md-6 col-lg-3">
                <div class="input-block">
                  <label class="focus-label">Cargo</label>
                  <vue-select :options="Level" placeholder="Choose Level" />
                </div>
              </div>
              <div class="col-md-6 col-lg-3">
                <div class="input-block">
                  <label class="focus-label">Fecha Inicio</label>
                  <div class="cal-icon">
                    <datepicker v-model="startdateThree" placeholder="Choose Date" class="form-control datetimepicker"
                      :editable="true" :clearable="false" />
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-3">
                <div class="input-block">
                  <label class="focus-label">Fecha Fin</label>
                  <div class="cal-icon">
                    <datepicker v-model="startdateFour" placeholder="Choose Date" class="form-control datetimepicker"
                      :editable="true" :clearable="false" />
                  </div>
                  <div class="new-addd">
                    <a id="remove_row" class="remove_row" @click="deleteexperience(index)">
                      Eliminar</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4>Idiomas</h4>
          </div>
          <div class="col-md-6">
            <div class="input-block">
              <label class="form-label">Lenguaje</label>
              <input type="text" class="form-control" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-block">
              <label class="focus-label">Nivel</label>
              <vue-select :options="levelLenguage" placeholder="Seleccionar nivel" />
              <div class="new-addd">
                <a class="add-new text-success" id="lang_add" @click="addlanguage"><i class="feather-plus-circle me-1"></i> Agregar nuevo</a>
              </div>
            </div>
          </div>
          <div id="language_add_row">
            <div class="row" v-for="(language, index) in languages" :key="index">
              <div class="col-md-12">
                <h4>Idiomas</h4>
              </div>
              <div class="col-md-6">
                <div class="input-block">
                  <label class="form-label">Lenguaje</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block">
                  <label class="focus-label">Nivel</label>
                  <vue-select :options="levelLenguage" placeholder="Seleccionar nivel" />
                  <div class="new-addd">
                    <a id="remove_row" class="remove_row" @click="deletelanguage(index)">
                      Eliminar</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h4>Redes Sociales</h4>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="focus-label">Red Social</label>
              <vue-select :options="socialNetworks" id="certification" placeholder="Select" />
            </div>
          </div>
          <div class="col-md-8 col-lg-8">
            <div class="input-block">
              <label class="focus-label">URL</label>
              <input type="text" name="certification['certified_from'][]" class="form-control" />
              <div class="new-addd">
                <a class="add-new text-success" id="certify_add" @click="addcertify"><i class="feather-plus-circle me-1 "></i> Agregar Nuevo</a>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="focus-label">Year</label>
              <div class="cal-icon">
                <datepicker v-model="startdateTwo" placeholder="Choose Date" class="form-control datetimepicker"
                  :editable="true" :clearable="false" />
              </div>
              <div class="new-addd">
                <a class="add-new" id="certify_add" @click="addcertify"><i class="feather-plus-circle me-1"></i> Add New</a>
              </div>
            </div>
          </div> -->
          <div id="certify_add_row">
            <div class="row" v-for="(certify, index) in certify" :key="index">
              <div class="col-md-12">
                <h5>Redes Sociales</h5>
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="input-block">
                  <label class="focus-label">Red Social</label>
                  <vue-select :options="socialNetworks" placeholder="Seleccionar red social" />
                </div>
              </div>
              <div class="col-md-8 col-lg-8">
                <div class="input-block">
                  <label class="focus-label">URL</label>
                  <input type="text" name="certification['certified_from'][]" class="form-control" />
                  <div class="new-addd">
                    <a id="remove_row" class="remove_row" @click="deletecertify(index)">
                      Eliminar</a>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-4 col-lg-4">
                <div class="input-block">
                  <label class="focus-label">Year</label>
                  <div class="cal-icon">
                    <datepicker v-model="startdateTwo" placeholder="Choose Date" class="form-control datetimepicker"
                      :editable="true" :clearable="false" />
                  </div>
                  <div class="new-addd">
                    <a id="remove_row" class="remove_row" @click="deletecertify(index)">
                      Remove</a>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="input-block">
                    <label class="form-label">Cargar CV</label>
                    <div class="upload-sets">
                        <label class="upload-filesview">
                            Buscar archivo
                            <input type="file" @change="handleFileUpload" accept=".pdf,.docx" />
                        </label>
                    </div>
                    <span v-if="fileName" class="file-name text-success text-center" style="width:100%">{{ fileName }}</span>
                </div>
                <span>
                    (Los formatos permitidos son .pdf, .docx)
                </span>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-12">
                <div>
                    <label class="custom_check">
                    <input type="checkbox" name="select_time" style="margin-top:-15px"/>
                    <span class="checkmark"></span>Me interesa recibir invitación para cargar mi perfil en Bumeran.com
                    </label>
                </div>
                <div>
                    <label class="custom_check">
                    <input type="checkbox" name="select_time" style="margin-top:-15px"/>
                    <span class="checkmark"></span>He leído y acepto los <span class="text-success">Términos y Condiciones</span> y las <span class="text-success">Políticas de Privacidad</span>
                    </label>
                </div>
            </div>
        </div>
        
        <!-- <div class="col-md-8 col-lg-8">
            <div class="input-block">
                <label class="focus-label">Cargar</label>
                <div>
                    <input type="file" @change="handleFileUpload" accept=".pdf,.doc,.docx" />
                    <button @click="saveFile">Guardar Archivo</button>
                </div>
            </div>
        </div> -->

        <!-- <div class="row">
          <div class="col-md-12">
            <h5>Certification</h5>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="focus-label">Certification or Award</label>
              <vue-select :options="Certification" id="certification" placeholder="Select" />
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="focus-label">Certified from</label>
              <input type="text" name="certification['certified_from'][]" class="form-control" />
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="focus-label">Year</label>
              <div class="cal-icon">
                <datepicker v-model="startdateTwo" placeholder="Choose Date" class="form-control datetimepicker"
                  :editable="true" :clearable="false" />
              </div>
              <div class="new-addd">
                <a class="add-new" id="certify_add" @click="addcertify"><i class="feather-plus-circle me-1"></i> Add New</a>
              </div>
            </div>
          </div>
          <div id="certify_add_row">
            <div class="row" v-for="(certify, index) in certify" :key="index">
              <div class="col-md-12">
                <h5>Certification</h5>
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="input-block">
                  <label class="focus-label">Certification or Award</label>
                  <vue-select :options="Certification" placeholder="Select" />
                </div>
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="input-block">
                  <label class="focus-label">Certified from</label>
                  <input type="text" name="certification['certified_from'][]" class="form-control" />
                </div>
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="input-block">
                  <label class="focus-label">Year</label>
                  <div class="cal-icon">
                    <datepicker v-model="startdateTwo" placeholder="Choose Date" class="form-control datetimepicker"
                      :editable="true" :clearable="false" />
                  </div>
                  <div class="new-addd">
                    <a id="remove_row" class="remove_row" @click="deletecertify(index)">
                      Remove</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="row">
          <div class="col-md-12">
            <h4>Skill</h4>
          </div>
          <div class="col-md-6">
            <div class="input-block">
              <label class="form-label">Skills</label>
              <input type="text" class="form-control" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-block">
              <label class="focus-label">Level</label>
              <vue-select :options="Level" placeholder="Choose Level" />
              <div class="new-addd">
                <a class="add-new" @click="addSkill" id="skill_add"><i class="feather-plus-circle me-1"></i> Add New</a>
              </div>
            </div>
          </div>
          <div id="skill_add_row">
            <div class="row" id="form-row" v-for="(skill, index) in skills" :key="index">
              <div class="col-md-12">
              </div>
              <div class="col-md-6">
                <div class="input-block">
                  <label class="form-label">Skills</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block">
                  <label class="focus-label">Level</label>
                  <vue-select :options="Level" placeholder="Choose Level" />
                  <div class="new-addd">
                    <a id="remove_row" class="remove_row" @click="deleteSkill(index)"> Remove</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </form>
    </div>
  </template>
  
  <script>
  import { ref } from "vue";
  const currentDate = ref(new Date());
  const currentDateOne = ref(new Date());
  const currentDateTwo = ref(new Date());
  const currentDateThree = ref(new Date());
  const currentDateFour = ref(new Date());
  export default {
    data() {
      return {
        levelLenguage: ["Basico", "Intermedio", "Avanzado"],
        Bachelor: ["Select", "Bachelor's degree", "Master's Degree"],
        Certification: ["Select", "Certification", "Award"],
        socialNetworks:["Linkedin","Facebook","Instagram","Tik Tok"],
        startdate: currentDate,
        startdateOne: currentDateOne,
        startdateTwo: currentDateTwo,
        startdateThree: currentDateThree,
        startdateFour: currentDateFour,
        skills: [],
        educations: [],
        certify: [],
        experiences: [],
        languages: [],
        fileName:null,
      }
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.fileName = file.name;
            } else {
                this.fileName = '';
            }
        },

        addSkill() {
        this.skills.push({
            skill: "",
            Level: "Choose Level",
        });
        },
        deleteSkill(index) {
        this.skills.splice(index, 1);
        },
        addeducation() {
        this.educations.push({});
        },
        deleteeducation(index) {
        this.educations.splice(index, 1);
        },
        addcertify() {
        this.certify.push({});
        },
        deletecertify(index) {
        this.certify.splice(index, 1);
        },
        addexperience() {
        this.experiences.push({});
        },
        deleteexperience(index) {
        this.experiences.splice(index, 1);
        },
        addlanguage() {
        this.languages.push({});
        },
        deletelanguage(index) {
        this.languages.splice(index, 1);
        },
    },
  }
  </script>